const addcart = "/api/store/cart";//post添加购物车 get获取购物车 单个商品
const batchCart = "/api/store/batchCart";//post添加购物车 get获取购物车 多个商品[]
const getorders = "/api/store/orders";//get获取用用户订单
const deletecart = "/api/store/cart/";//删除商品
const changequantity = "/api/store/cart/";//PUT 修改商品数量
const batch_update = "api/store/cart/batch_update";//post  批量修改商品数量
const address = "/api/store/cart/address";//设置配送地址
const shipping_method = "/api/store/cart/shipping";//设置配送方式
const set_payment = "/api/store/cart/payment";//设置支付方式
const checkout = "/api/store/cart/checkout";//post生成订单
const setaddress = "/api/store/addresses";// POST添加地址S
const deleteaddress = "/api/store/addresses/";//DELETE 删除地址
const updateaddress = "/api/store/addresses/";//PUT 更新地址
const exchanges = "/api/store/exchanges" //GET获取税率
const testdiscount = "/api/store/cart/coupons" //post添加优惠券
const deletediscount = "/api/store/cart/coupons/" //delete删除优惠券
const start_checkout = "/api/store/cart/start_checkout" //post 快速结账
const subscribe = "/api/contacts" //post 订阅邮箱
const statis_event = "/api/statistics/events" //post 分享统计
const auto_complete = "/api/store/place-auto-complete" //post 自动填充
const comment_attachments = "/api/store/attachments" //图片上传
const last_sales = "/api/store/last-sales" //最近购买记录
const ipinfo = "/api/store/ip" //获取ip信息
const worldpay = "https://api.worldpay.com/v1/tokens" //获取ip信息

export default {
    batchCart,
    addcart,
    deletecart,
    changequantity,
    address,
    shipping_method,
    set_payment,
    checkout,
    setaddress,
    deleteaddress,
    updateaddress,
    exchanges,
    testdiscount,
    deletediscount,
    start_checkout,
    subscribe,
    statis_event,
    auto_complete,
    comment_attachments,
    batch_update,
    getorders,
    last_sales,
    ipinfo,
    worldpay
}